<script>
  import {VueMaskDirective as mask} from 'v-mask'
  import service from '../../../../domain/eventos/services'
  import {isArray} from 'lodash'
  import {REAL_BRL} from '../../../../utils/helpers/money'
  import {VMoney} from 'v-money'

  export default {
    components: {},
    nome: 'evento',
    directives: {mask, money: VMoney},
    data () {
      return {
        money: REAL_BRL,
        isLoading: false,
        isLoaded: false,
        cadastroError: null,
        atualizadoSucesso: null,
        data: {
          id: null,
          titulo: null,
          data: null,
          descricao: null,
          status: null
        }
      }
    },
    computed: {},
    mounted () {
      this.start()
    },
    activated () {
    },
    destroyed () {
    },
    watch: {},
    methods: {
      start () {
        if (this.$route.params.id) {
          this.$loaderOverlay.open().message('Carregando')
          service.find(this.$route.params.id)
            .then((response) => {
              this.isLoaded = true
              this.$loaderOverlay.hide()
              this.data = response.data
              this.ajustaValores()
              console.log(response)
            })
            .catch((response) => {
              this.$loaderOverlay.hide()
              console.log(response)
            })
        } else {
          // this.$loaderOverlay.open().message('Aguarde')
          this.isLoaded = true
        }
      },
      transformDataToSend (originData) {
        let data = Object.assign({}, originData)
        console.log(data)
        if (data.data.length === 10) {
          let dataExp = data.data.split('/')
          data.data = dataExp[2] + '-' + dataExp[1] + '-' + dataExp[0]
          console.log(data.data)
        }
        return data
      },
      ajustaValores (inversed) {
        inversed = inversed || false
        if (inversed) {
          console.log('Inversed fields to data')
        } else {
          //
          console.log(this.data)
          if (typeof this.data.data.date !== 'undefined') {
            let date = this.data.data.date.split(' ').shift().split('-')
            this.data.data = date[2] + '/' + date[1] + '/' + date[0]
          }
        }
      },
      submit () {
        this.ajustaValores(true) // inversed
        this.cadastroError = null
        this.atualizadoSucesso = false
        this.$loaderOverlay.open().message('Processando')
        this.$bar.start()
        window.setTimeout(() => {
          this.$loaderOverlay.message('Aguarde...')
        }, 1000)
        service.cadastro(this.transformDataToSend(this.data), this.$route.params.id).then((response) => {
          let callbackEnd = () => {
            this.$bar.finish()
            this.$loaderOverlay.hide()
            if (this.$route.params.id) {
              // Continua na mesma tela de edição
              // this.$nextTick(() => {
              this.start()
              this.atualizadoSucesso = true
              this.$el.querySelector('#sucessMsg').focus()
              // })
            } else {
              // Redirecionr para tela de visualização do arrematante
              this.$router.push({name: 'eventos.visualizar', params: {id: response.data.id}})
            }
          }
          callbackEnd()
        }).catch((response) => {
          this.$bar.finish()
          this.$loaderOverlay.hide()
          this.cadastroError = response.data.errors
          this.$nextTick(() => {
            this.$refs.error.focus()
          })
          console.log(response)
        })
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Cadastro de Evento</h1></div>
          <div class="col-sm-6">
            <router-link v-if="data.id" :to="{name: 'eventos.visualizar', params: {id: data.id}}"
                         class="pull-right hidden-print" style="clear: left">
              <strong class="label no-radius bg-info">Voltar</strong>
            </router-link>
          </div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao registrar, corrija e tente novamente</div>
              <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
            </div>
            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null && atualizadoSucesso"
                 class="alert alert-success">
              <div class="font-bold">Atualizado com sucesso!</div>
            </div>
            <form @submit.prevent.stop="" class="bs-example form-horizontal">

              <div class="form-group">
                <label class="col-sm-2 control-label">Título</label>
                <div class="col-sm-10">
                  <input type="text" v-model="data.titulo" class="form-control"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-lg-2 control-label">Data do Evento</label>
                <div class="col-lg-10">
                  <input placeholder="dd/mm/yyyy" class="form-control w-full-xs w-sm " v-model="data.data"
                         v-mask="'##/##/####'"/>
                </div>
              </div>


              <div class="form-group">
                <label class="col-sm-2 control-label"></label>
                <div class="col-sm-10">
                  <strong>Informações Adicionais</strong>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-2 control-label">Descrição</label>
                <div class="col-sm-10">
                  <textarea v-model="data.descricao" class="form-control" style="height: 300px"></textarea>
                </div>
              </div>

              <div class="clearfix"></div>

              <hr>
              <div class="row wrapper">
                <u-button @click="submit" class="btn m-b-xs w-xs btn-info m-r-xs">
                  <span v-if="!data.id">Cadastrar</span>
                  <span v-if="data.id">Atualizar</span>
                </u-button>
                <u-button class="btn m-b-xs w-xs m-r-xs btn-default">Cancelar</u-button>
                <span v-if="!data.id">Ao cadastrar, o status do evento será <span class="text-info">Rascunho</span>, para publicá-lo, altere o status após o cadastro.</span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// Evento.vue?1a1508e0